<template>
  <div>
    <h2 class="page-header">
      Unit Measure
    </h2>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> UOM Name KH</label>
              <div class="col-md-7">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('uom_name_kh') }"
                  v-model="model.uom_name_kh"
                  placeholder="UOM name Kh"
                />
                <div class="invalid-feedback" v-if="errors.has('uom_name_kh')">
                  {{ errors.first('uom_name_kh') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                UOM Name EN <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <input
                  v-model="model.uom_name_en"
                  type="text"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('uom_name_en') }"
                  placeholder="UOM name En"
                />
                <div class="invalid-feedback" v-if="errors.has('uom_name_en')">
                  {{ errors.first('uom_name_en') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Quantity
              </label>
              <div class="col-md-7">
                <input type="number" class="form-control" v-model.number="model.uom_qty" placeholder="UOM QTY" />
                <div class="invalid-feedback" v-if="errors.has('uom_qty')">
                  {{ errors.first('uom_qty') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"></label>
              <div class="col-sm-7">
                <div class="checkbox checkbox-css">
                  <input type="checkbox" id="cssCheckbox1" v-model="model.is_default" />
                  <label for="cssCheckbox1"> Default</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row  text-right">
          <div class="col-lg-12">
            <ts-button class="ml-2" color="primary" :waiting="saving" @click="update">
              Update
            </ts-button>

            <ts-button class="ml-2" @click="$router.push({ name: 'unit-measure' })">
              Cancel
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import apiMeasure from '@/api/inventory/unit-measure'

export default {
  name: 'measure-update',
  beforeRouteEnter: async (to, from, next) => {
    let response = await apiMeasure.find(to.params.id)
    to.params.editData = response.data
    next(vm => vm.setEditData())
  },
  props: ['editData'],
  data() {
    return {
      model: {
        uom_id: '',
        uom_name_kh: '',
        uom_name_en: '',
        uom_qty: '',
        is_default: false
      },
      errors: new Errors(),
      saving: false
    }
  },
  methods: {
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('inventory/unitMeasure/update', Object.assign({}, this.model))
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'unit-measure' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
          this.$toasted.error(error.message)
        })
    },

    setEditData() {
      this.model.uom_id = this.editData.uom_id
      this.model.uom_name_kh = this.editData.uom_name_kh
      this.model.uom_name_en = this.editData.uom_name_en
      this.model.uom_qty = parseInt(this.editData.uom_qty, 10)
      this.model.is_default = this.editData.is_default
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('inventory/unitMeasure/RESET_STATE')
    }
    next()
  }
}
</script>
